export const gramsToKilos = (grams: number) => {
  return grams / 1000;
};

export const kilosToGrams = (kilos: number) => {
  return kilos * 1000;
};
